import { PulseSurveyStatus } from 'api/actions/pulseSurveys/pulseSurveysActions.types'

export const ACTION_ALLOWED_STATUTES: Record<'update' | 'publish' | 'close' | 'delete', PulseSurveyStatus[]> = {
    update: ['edit_in_progress', 'sm_creation_failed', 'survey_dump_creation_failed', 'sm_creation_failed'],
    publish: ['edit_in_progress', 'sm_creation_failed', 'survey_dump_creation_failed', 'sm_collector_link_failed'],
    close: ['sm_publish_success', 'sm_survey_close_failed'],
    delete: [
        'edit_in_progress',
        'sm_creation_failed',
        'survey_dump_creation_failed',
        'sm_collector_link_failed',
        'survey_question_creation_failed',
        'sm_publish_success',
        'sm_collector_close_failed',
        'sm_responses_sync_failed',
        'survey_answers_creation_failed',
        'ready_for_results',
    ],
}
